<template>
  <div>
    <!--    <span>{{messageType}}</span><br/>
    <span>{{linkedEntityID}}</span><br/>
    <span>{{currentCategory}}</span><br/>
 -->
  </div>
</template>
<script type="text/javascript">
import {
  FITPagination,
  FITFormCard,
  FITSelect,
  FITButton,
  FITTextInput,
  FITDatePicker,
  FITSearchableTable
} from '@/components';
import Vue from 'vue';
import Moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'NotificationRouter',
  props: {
    messageType: {
      type: String,
      default: ""
    },
    linkedEntityID: {
      type: String,
      default: ""
    },
    currentCategory: {
      type: String,
      default: ""
    },
    reminderDate:{
      type:String,
      // default:""
    }
  },
  data() {
    return {

    }
  },
  created() {
    // Redirect Notifiction item to Entity;
    switch (this.currentCategory) { // "["M", "B", "R", "C"]
      case "M":
        // Message Type
        switch (this.messageType) {
          case "P": // Life
            this.$store.commit({ type: 'LifePolicy/setLifePolicyID', policyID: this.linkedEntityID });
            this.$store.dispatch('LifePolicy/getLifeDetail').then((response) => {
              // console.log(response);
              let policyID = this.linkedEntityID;
              let wfStep = parseInt(response.workFlowStep);
              this.lifePolicyRouter(policyID, wfStep);
            });
            break;
          case "G": // GI 
            this.$store.commit({ type: 'GIPolicy/setGIPolicyID', policyID: this.linkedEntityID });
            this.$store.dispatch('GIPolicy/getGIDetail').then((response) => {
              // console.log(response);
              let policyID = this.linkedEntityID;
              let wfStep = parseInt(response.giGeneralInfo.workFlowStep);
              this.GIPolicyRouter(policyID, wfStep);
            });
            break;
          case "S": // Sevice Request 
            this.$store.dispatch('ServiceRequest/getServiceRequestDetail', { ID: this.linkedEntityID }).then((response) => {
              console.log(response);
              let serviceID = this.linkedEntityID;
              let serviceType = response.data.serviceType;
              let policyID = response.data.linkedEntityID;
              let policyType = response.data.linkedEntity;
              this.ServiceRequestRouter(serviceID, serviceType, policyID, policyType);
            });
            break;
          case "C": // Claim
            this.$store.dispatch('Claim/getClaimDetail', { ID: this.linkedEntityID }).then((json) => {
              console.log(json);
              let detail = {};
              detail.ID = json.data.ID;
              detail.wfStep = parseInt(json.data.workFlowStep);
              detail.claimStatus = json.data.status;
              detail.policyID = json.data.policyID;
              detail.policyType = json.data.policyType;
              detail.productEnglishName = json.data.productEnglishName;
              detail.productChineseName = json.data.productChineseName;

              this.ClaimRouter(detail);
            });
            break;
        }
        break;
      case "B":
        break;
      case "R":
      // console.log(this.reminderDate)
             this.$router.replace({
            name: 'Quick Renew',
            params: {           
              paymentDate: this.reminderDate,              
            }
          });
        break;
      case "C": // Commission
      let type = this.messageType.replace("Commission","");
      this.$router.replace({
            path: `/adm/${type}-commission`,
          })    
        break;
    }
  },
  methods: {
    lifePolicyRouter(policyID, wfStep) {
      switch (wfStep) {
        case 8:
          this.$store.commit({ type: 'LifePolicy/setIsCompleted', value: true })
          this.$router.replace({
            path: '/osm/life/detail',
            query: { ID: policyID }
          })
          return;
        case 5:
        case 6:
        case 7:
          this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', (wfStep + 1))
          break;
        case 4:
          this.$store.commit({ type: 'LifePolicy/setIsRejected', value: true })
        default:
          this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', wfStep)
          break;
      }
      this.$router.replace('/osm/life/new');
    },
    GIPolicyRouter(policyID, wfStep) {
      switch (wfStep) {
        case 8:
          this.$store.commit({ type: 'GIPolicy/setIsCompleted', value: true })
          this.$router.push('/osm/gi/detail')
          return;
        case 5:
        case 6:
        case 7:
          this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', (wfStep + 1))
          break;
        case 4:
          this.$store.commit({ type: 'GIPolicy/setIsRejected', value: true })
        default:
          this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', wfStep)
          break;
      }
      this.$router.push('/osm/gi/new');
    },
    ServiceRequestRouter(serviceID, serviceType, policyID, policyType) {
      this.$router.replace({
        name: `serviceRequest-${serviceType.toLowerCase()}`,
        params: {
          ID: parseInt(serviceID),
          policy: {
            policyID: policyID,
            policyType: policyType
          }
        }
      });
    },
    ClaimRouter(detail) {
      /** detail:{
        ID: claim.ID;
        policyID: claim.linkedEntityID;
        policyType: claim.linkedEntity
        productEnglishName,
        productChineseName,
        wfStep,
        claimStatus, 
      }**/
      this.$store.commit({ type: 'Claim/setNextWorkFlowStep', nextStep: detail.wfStep });
      this.$store.commit({ type: 'Claim/setClaimID', ID: parseInt(detail.ID) });
      switch (detail.claimStatus) {
        case 'R':
        case 'C':
          this.$router.replace({
            name: 'Claim Detail',
            params: { detail: detail }
          })
          break;
        default:
          this.$router.replace({
            name: 'Create Claim',
            params: { detail: detail, ClaimHeader: this.$t('osm.Claim.edit.header') }
          });
          break;
      }

    }
  },


}

</script>



// WEBPACK FOOTER //
// src/Crm/components/Notification/NotificationRouter.vue